import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Heart, Home, ArrowRight } from 'lucide-react';
import { Header } from '../components/Header';
import { GlassCard } from '../components/ui/GlassCard';
import { DonateModal } from '../components/DonateModal';
export function DonationSuccessPage() {
  const [isDonateModalOpen, setIsDonateModalOpen] = useState(false);
  const currentYear = new Date().getFullYear();
  return <div className="min-h-screen bg-black text-white flex flex-col" data-id="element-1028">
      {/* Background */}
      <div className="fixed inset-0 z-0 pointer-events-none" data-id="element-1029">
        <div className="absolute top-0 left-0 w-[600px] h-[600px] bg-gradient-to-br from-cyan-500/10 to-blue-500/10 rounded-full blur-[120px]" data-id="element-1030" />
        <div className="absolute bottom-0 right-0 w-[700px] h-[700px] bg-gradient-to-tl from-purple-500/10 to-pink-500/10 rounded-full blur-[120px]" data-id="element-1031" />
      </div>

      <Header data-id="element-1032" />

      <div className="relative z-10 flex-1 flex items-center justify-center px-4 py-12" data-id="element-1033">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="w-full max-w-2xl" data-id="element-1034">
          <GlassCard className="p-12 text-center" data-id="element-1035">
            {/* Success Icon */}
            <motion.div initial={{
            scale: 0
          }} animate={{
            scale: 1
          }} transition={{
            delay: 0.2,
            type: 'spring',
            stiffness: 200
          }} className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-gradient-to-br from-green-500/20 to-emerald-500/20 border border-green-500/30 mb-6" data-id="element-1036">
              <Heart size={48} className="text-green-400 fill-green-400" data-id="element-1037" />
            </motion.div>

            {/* Heading */}
            <motion.h1 initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.3
          }} className="text-4xl md:text-5xl font-bold text-white mb-4 font-special" data-id="element-1038">
              Thank You!
            </motion.h1>

            {/* Message */}
            <motion.p initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.4
          }} className="text-gray-400 text-lg mb-8 leading-relaxed" data-id="element-1039">
              Your generous donation helps us keep Faind free and updated daily
              with the latest AI tools. We truly appreciate your support! 🙏
            </motion.p>

            {/* Stats */}
            <motion.div initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.5
          }} className="grid grid-cols-3 gap-4 mb-8" data-id="element-1040">
              <div className="p-4 rounded-lg bg-white/5 border border-white/10" data-id="element-1041">
                <div className="text-2xl font-bold text-cyan-400 mb-1" data-id="element-1042">
                  1000+
                </div>
                <div className="text-xs text-gray-500" data-id="element-1043">AI Tools</div>
              </div>
              <div className="p-4 rounded-lg bg-white/5 border border-white/10" data-id="element-1044">
                <div className="text-2xl font-bold text-purple-400 mb-1" data-id="element-1045">
                  Daily
                </div>
                <div className="text-xs text-gray-500" data-id="element-1046">Updates</div>
              </div>
              <div className="p-4 rounded-lg bg-white/5 border border-white/10" data-id="element-1047">
                <div className="text-2xl font-bold text-pink-400 mb-1" data-id="element-1048">
                  100%
                </div>
                <div className="text-xs text-gray-500" data-id="element-1049">Free</div>
              </div>
            </motion.div>

            {/* Action Buttons */}
            <motion.div initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.5
          }} className="flex flex-col sm:flex-row gap-3 justify-center" data-id="element-1050">
              <Link to="/" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg bg-gradient-to-r from-cyan-400 to-purple-400 hover:from-cyan-500 hover:to-purple-500 text-white font-bold transition-all" style={{
              fontFamily: 'Space Grotesk, sans-serif'
            }} data-id="element-1051">
                <Home size={20} data-id="element-1052" />
                <span data-id="element-1053">Back to Home</span>
              </Link>

              <Link to="/" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg bg-white/5 hover:bg-white/10 border border-white/10 hover:border-white/20 text-white font-medium transition-all" data-id="element-1054">
                <span data-id="element-1055">Explore AI Tools</span>
                <ArrowRight size={20} data-id="element-1056" />
              </Link>
            </motion.div>

            {/* Footer Note */}
            <motion.p initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            delay: 0.7
          }} className="text-sm text-gray-500 mt-8" data-id="element-1057">
              You'll receive a confirmation email from PayPal shortly
            </motion.p>
          </GlassCard>
        </motion.div>
      </div>

      {/* Footer */}
      <footer className="relative z-10 border-t border-white/10 py-6 bg-black/80 backdrop-blur-lg" data-id="element-1058">
        <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-1059">
          <div className="flex items-center gap-2" data-id="element-1060">
            <span style={{
            fontFamily: 'Space Grotesk, sans-serif',
            fontWeight: 300,
            fontSize: '1.125rem',
            lineHeight: '1.75rem',
            letterSpacing: '.15em'
          }} className="text-white" data-id="element-1061">
              FAIND
            </span>
          </div>
          <div className="text-gray-500 text-sm" data-id="element-1062">
            © {currentYear} Faind. All rights reserved.
          </div>
          <div className="flex items-center gap-6" data-id="element-1063">
            <a href="https://x.com/faindyourapp" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" aria-label="Follow us on X" data-id="element-1064">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" data-id="element-1065">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" data-id="element-1066" />
              </svg>
            </a>
            <button onClick={() => setIsDonateModalOpen(true)} className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-white/5 hover:bg-white/10 border border-white/10 hover:border-pink-500/30 text-gray-400 hover:text-pink-400 transition-all text-sm font-medium" data-id="element-1067">
              <Heart size={14} data-id="element-1068" />
              Donate
            </button>
          </div>
        </div>
      </footer>

      <DonateModal isOpen={isDonateModalOpen} onClose={() => setIsDonateModalOpen(false)} data-id="element-1069" />
    </div>;
}